import { QueryClient } from "@tanstack/react-query";

/**
 * Project-wide TanStack Query client.
 *
 * Conservative defaults; individual queries can override.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
